import { useTranslation } from 'react-i18next';

export const useTqEnAgreedExtensionStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('tqen_agreed_extension_stats_annual_report');

  const tqEnAgreedExtensionStatsLabels: Record<string, string> = {
    totalConsultationsWithExtensionsTimeframe: t(
      'tqen_total_consultations_with_extensions_timeframe',
      'Total number of consultations with agreed extensions of timeframe'
    ),
    totalConsultationResponsesWithinExtensionTimeframe: t(
      'tqen_total_consultation_responses_within_extension_timeframe',
      'Total number of consultation responses returned within an agreed extension timeframe'
    ),
    totalConsultationsWithExtensionsTimeframeExtended1To7Days: t(
      'tqen_total_consultations_with_extensions_timeframe_extended_1_to_7_days',
      'Total number of consultations with agreed extensions of timeframe extended by 1-7 days'
    ),
    percentageConsultationsWithExtensionsTimeframeExtended1To7Days: t(
      'tqen_percentage_consultations_with_extensions_timeframe_extended_1_to_7_days',
      'Percentage of consultations with agreed extensions of timeframe extended by 1-7 days'
    ),
    totalConsultationsWithExtensionsTimeframeExtended8To14Days: t(
      'tqen_total_consultations_with_extensions_timeframe_extended_8_to_14_days',
      'Total number of consultations with agreed extensions of timeframe extended by 8-14 days'
    ),
    percentageConsultationsWithExtensionsTimeframeExtended8To14Days: t(
      'tqen_percentage_consultations_with_extensions_timeframe_extended_8_to_14_days',
      'Percentage of consultations with agreed extensions of timeframe extended by 8-14 days'
    ),
    totalConsultationsWithExtensionsTimeframeExtended15To21Days: t(
      'tqen_total_consultations_with_extensions_timeframe_extended_15_to_21_days',
      'Total number of consultations with agreed extensions of timeframe extended by 15-21 days'
    ),
    percentageConsultationsWithExtensionsTimeframeExtended15To21Days: t(
      'tqen_percentage_consultations_with_extensions_timeframe_extended_15_to_21_days',
      'Percentage of consultations with agreed extensions of timeframe extended by 15-21 days'
    ),
    totalConsultationsWithExtensionsTimeframeExtended22To28Days: t(
      'tqen_total_consultations_with_extensions_timeframe_extended_22_to_28_days',
      'Total number of consultations with agreed extensions of timeframe extended by 22-28 days'
    ),
    percentageConsultationsWithExtensionsTimeframeExtended22To28Days: t(
      'tqen_percentage_consultations_with_extensions_timeframe_extended_22_to_28_days',
      'Percentage of consultations with agreed extensions of timeframe extended by 22-28 days'
    ),
    totalConsultationsWithExtensionsTimeframeExtended29PlusDays: t(
      'tqen_total_consultations_with_extensions_timeframe_extended_29_plus_days',
      'Total number of consultations with agreed extensions of timeframe extended by 29 days and over'
    ),
    percentageConsultationsWithExtensionsTimeframeExtended29PlusDays: t(
      'tqen_percentage_consultations_with_extensions_timeframe_extended_29_plus_days',
      'Percentage of consultations with agreed extensions of timeframe extended by 29 days and over'
    ),
  };

  return tqEnAgreedExtensionStatsLabels;
};
